import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette, colors }: Theme) => createStyles({
  root: {
    width: '100%',
  },
  popper: {
    zIndex: 2147483100,
  },
  input: {},
  labelRoot: {
    '&$focused': {
      color: palette.text.secondary,
    },
  },
  labelRootError: {
    color: '#F8221A',
  },
  inputUnderline: {
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$focused:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$disabled:before': {
      borderBottomStyle: 'dashed',
    },
  },
  inputUnderlineError: {
    '&:before': {
      borderBottom: '2px solid #F8221A',
    },
    '&&:hover:before': {
      borderBottomColor: `#F8221A`,
    },
  },
  focused: {},
  hovered: {},
  disabled: {
    color: palette.disabledInput.color,
  },
  loader: {
    width: '16px !important',
    height: '16px !important',
  },
  icon: {
    marginLeft: 8,
    color: colors.icon,
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  iconTooltip: {
    fontSize: 14,
    color: colors.icon,
    verticalAlign: 'middle',
    marginBottom: 4,
    marginLeft: 8,
  },
  commentButtonWrapper: {
    textAlign: 'center',
  },
  comment: {
    fontSize: '12px',
    padding: '0 10px 0 10px',
  },
}), { name: 'FormAutoComplete' });

export default useStyles;
